import {
  ActivityEnrollableTimesQuery,
  ActivityEnrollableTimesQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useApolloClient } from "@outschool/ui-apollo";
import { useFundingProgramAbbr } from "@outschool/ui-auth";
import React from "react";

import ActivityEnrollableTimesModal from "../ClassDetailsPage/ActivityEnrollableTimes/ActivityEnrollableTimesModal";

const activityEnrollableTimesQuery = gql`
  query ActivityEnrollableTimes(
    $uid: ID!
    $esaState: String
    $startAfter: DateTime
    $endBy: DateTime
    $filterByDow: [Int]
    $recurringOnly: Boolean
  ) {
    activity(uid: $uid) {
      ...ActivityEnrollableTimesModal_activity
    }
  }
  ${ActivityEnrollableTimesModal.fragments.activity},
`;

export default function useFetchEnrollableTimes({
  startAfter,
  endBy,
  filterByDow,
}: {
  startAfter?: Date | undefined;
  endBy?: Date | undefined;
  filterByDow?: number[] | undefined;
} = {}) {
  const client = useApolloClient();
  const esaState = useFundingProgramAbbr();
  return React.useCallback(
    async (uid: string) => {
      const { data } = await client.query<
        ActivityEnrollableTimesQuery,
        ActivityEnrollableTimesQueryVariables
      >({
        query: activityEnrollableTimesQuery,
        variables: {
          uid,
          esaState,
          startAfter,
          endBy,
          filterByDow,
          recurringOnly: false,
        },
        fetchPolicy: "network-only",
      });
      if (!data || !data.activity) {
        throw new Error("Activity not found");
      }
      return data.activity;
    },
    [client, esaState, startAfter, endBy, filterByDow]
  );
}
